import { PropsWithChildren } from 'react'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'

import { FragmentType, gql, useFragment } from 'graphql-generated'

import {
  EntryProgress,
  EntryProgressBar,
  EntryPublicationStatus,
  Timestamp,
  useEntryProgress,
} from 'common'

const ENTRY_FRAGMENT = gql(`
  fragment PublicProfile_Contributions_Entry on polls_entity {
    ...EntryProgress
  }
`)

type TableCellProps = PropsWithChildren<{
  className?: string
  colSpan?: number
}>

function TableCell({ children, colSpan, className }: TableCellProps) {
  return (
    <td
      colSpan={colSpan}
      className={classNames(
        'border-b border-gray-300 py-4 px-3 align-top first:pl-0 last:pr-0 group-last:border-none',
        className
      )}
    >
      {children}
    </td>
  )
}

type EntryProps = {
  entryRef: FragmentType<typeof ENTRY_FRAGMENT>
}

export default function Entry(props: EntryProps) {
  const fragment = useFragment(ENTRY_FRAGMENT, props.entryRef)
  const entry = useEntryProgress(fragment)

  return (
    <tr className="group">
      <TableCell className="align-top">
        <NavLink className="link" to={`/browse/${entry.id}`}>
          {entry.name}
        </NavLink>
      </TableCell>

      <TableCell className="w-1/4 !px-0 align-top lg:w-2/6">
        <EntryProgressBar entry={entry} />
      </TableCell>

      <TableCell className="align-top text-5xl text-neutral-400">
        <EntryProgress entry={entry} />
      </TableCell>

      <TableCell className="py-4 align-top text-neutral-600">
        <EntryPublicationStatus entry={entry} />
      </TableCell>

      <TableCell className="py-4 align-top text-neutral-600">
        <Timestamp date={entry.dateModified} />
      </TableCell>
    </tr>
  )
}
